export default name => {
  if (name.includes('360_scene')) return '360'
  if (name.includes('intersection_fov')) return 'Intersection'
  if (name.includes('doorway_fov')) return 'Doorway'
  if (name.includes('hallway_fov')) return 'Hallway'
  if (name.includes('indoor_room_fov')) return 'Indoor Room'
  if (name.includes('lobby_fov')) return 'Lobby'
  if (name.includes('parking_lot_fov')) return 'Parking Lot'
  if (name.includes('vehicle_entrance_fov')) return 'Vehicle Entrance'
  if (name.includes('composite')) return 'Intersection'
  return console.log(`GENERAL SCENE NAME NOT FOUND: ${name}`) || 'Intersection'
}



// WEBPACK FOOTER //
// ./src/schemas/migrator/helpers/findGeneralSceneName.js